import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiX } = FiIcons;

const CoverageSection = () => {
  const perfectFor = [
    "Small businesses (under $5M revenue)",
    "Retail, restaurants, salons, consultants",
    "Tech & online businesses",
    "Service providers (cleaning, landscaping)",
    "Startups with under 10 employees"
  ];

  const notFor = [
    "High-risk industries (heavy construction, roofing)",
    "Large companies over $5M revenue",
    "Specialized industries (aviation, marine)"
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Is This <span className="text-blue-600">Right For You?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Our coverage works best for certain types of businesses
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-green-50 rounded-3xl p-8 border border-green-200"
          >
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-green-600 w-12 h-12 rounded-full flex items-center justify-center">
                <SafeIcon icon={FiCheck} className="text-white text-2xl" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Perfect For</h3>
            </div>
            <div className="space-y-4">
              {perfectFor.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <SafeIcon icon={FiCheck} className="text-green-600 flex-shrink-0 mt-1" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="bg-red-50 rounded-3xl p-8 border border-red-200"
          >
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-red-600 w-12 h-12 rounded-full flex items-center justify-center">
                <SafeIcon icon={FiX} className="text-white text-2xl" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Not Ideal For</h3>
            </div>
            <div className="space-y-4">
              {notFor.map((item, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <SafeIcon icon={FiX} className="text-red-600 flex-shrink-0 mt-1" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mt-16"
        >
          <motion.a
            href="https://quote.burbankinsuranceservices.com/Jn9lan"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-colors duration-300 inline-block"
          >
            Check Your Eligibility
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default CoverageSection;